/* eslint-disable max-lines-per-function */
import React, { FC, createElement, useEffect, useState } from 'react';
import {
  countZero,
  getFalconGradientClass,
  getLocalStorageWithExpiry,
  setLocalStoreWithExpiry,
  viewport,
  replacePlaceholder
} from '../../utils/utils';
import './freshBanner.css';
import FreshProductDetails from './FreshProductDetails';
import { FreshBannerSchema } from './freshBanner.types';
import RichText from '../richtext';
import { createCartV2, createCartWinV2, getVocherPromotion } from '../../services/LineTableService';
import {
  CURRENCY,
  DEFAULT,
  DEFAULT_MOBILEPOSTPAID_BUNDLE,
  DEFAULT_WIRELINE_BUNDLE,
  INTERNET,
  MOBILE,
  NONE,
  QOQA_RATE_PLAN,
  YOUTH
} from '../../utils/constants';
import Row from '../ResponsiveRow/row';
import { getEcomCartInfo, trackEligibleItem } from '../../models/Analytics/items';
import { trackNewDatalayerEvent } from '../../utils/AnalyticsUtils';
import {
  ADDTOCART,
  COMBINEDEVICE,
  DOWNLOADPRODUCT,
  GAEVENT,
  SELECTPROMOTION,
  STAGETEASER,
  VIEWPROMOTION
} from '../../Analytics/AnalyticsConstants';
import Timer, { TimerSchema } from './Timer/Timer';
import { CheckTime } from './Timer/util';
import { v4 as generateUID } from 'uuid';
import ToolTip from '../ToolTip/ToolTip';
import { APIResourceConstants } from '../../services/api-constants';
import { ApiServiceV2 } from '@sunrise-upc/ajax-lib';
import Cookies from 'js-cookie';
import { LineTableBasicPropConfig } from '../../services/LineTableBasicPropConfig';
import GiftConfigV2 from '../Gift/GiftConfigV2';
import ChooseGiftV2 from '../Gift/ChooseGiftV2';
import LinecheckModal from '../LineCheckV3/LinecheckModal';
import Dotloader from '../Dotloader/Dotloader';
import SkeletonLoader from '../SkeletonLoader/SkeletonLoader';
import { LinecheckBasicPropConfig } from '../../services';
import CoverageCheckModal from '../NewLineCheck/CoverageCheckModal';
import LoginModalV2 from '../login/LoginModalV2';
import { Form } from 'react-bootstrap';

const FreshProductBannerHome: FC<FreshBannerSchema> = ({
  content,
  lineCheckCallBack,
  lineCheckSuccessCallBack,
  tableSelectedTab,
  baseConfig,
  authData,
  metadata,
  lineCheckOnClear,
  isProdEnv
}: any) => {
  const viewPort = viewport();
  const [offerResponse, setOfferResponse] = useState<any>([]);
  const [giftItem, setGiftItem] = useState<any>([]);
  const [toggle, setToggle] = useState(false);
  const [showLogin, setShowLogin] = useState(false);
  const [loginButtonClicked, setLoginButtonClicked] = useState(false);
  const normalizedGlobalGradient = content?.gradientBackgroundGlobal?.replace(/;\s*$/, '')?.trim();
  const hasGlobalGradient =
    !!normalizedGlobalGradient && normalizedGlobalGradient.toLowerCase() !== NONE;
  const gradientStyle = !hasGlobalGradient
    ? getFalconGradientClass(content?.backgroundGradient)
    : '';

  const code = toggle ? content?.tvProductId : content?.productId;
  const cartEndPoint = LineTableBasicPropConfig?.getInstance()?.getCartUrl();
  const [offerResponsefromApi, setOfferResponsefromApi] = useState<any>('');
  let address: any = Cookies.get('chAddressJson');
  const endPoint = LineTableBasicPropConfig?.getInstance()?.getBaseUrl();
  const [showLoader, setShowLoader] = useState<boolean>(false);
  const [click, setClick] = useState<boolean>(false);
  const [showLinecheck, setShowLinecheck] = useState(false);
  const [editClick, setEditClick] = useState<boolean>(false);
  const contentData = content?.ratePlanDetail?.[0];
  const combineWithSmartphoneUrl = `${
    contentData?.combineSmartphoneLink?.url ?? ''
  }?componentCode=&productType=subscription&segmentCode=RC&prefPromo=${
    content?.promotionId ?? ''
  }&productCode=${content?.productId ?? ''}`;
  const params = [
    {
      id: `${content?.productId ?? ''}`,
      promoIds: [`${content?.promotionId ?? ''}`]
    }
  ];

  LinecheckBasicPropConfig.create({ baseURL: `${baseConfig}` });

  const enableToggle = tableSelectedTab === content?.selectedTabId;
  useEffect(() => {
    setToggle(enableToggle);
  }, [enableToggle]);

  let bundle = typeof window !== 'undefined' && localStorage.getItem('lineCheckResponse');
  let eligibleBundle = bundle && JSON.parse(bundle);
  let isAvailable = address && eligibleBundle?.eligibleBundle?.includes(code);
  const linecheckId: any =
    typeof window !== 'undefined' && Cookies.get('one-commerce-linecheckcorrelationid');

  const callCart = (product: any) => {
    if (product?.productType === INTERNET) {
      bundle = typeof window !== 'undefined' && localStorage.getItem('lineCheckResponse');
      address = typeof window !== 'undefined' && Cookies.get('chAddressJson');
      eligibleBundle = bundle && JSON.parse(bundle);
      isAvailable = address && eligibleBundle?.eligibleBundle?.includes(code);
      const promoId = toggle ? product?.tvProductPromotionId : product?.promotionId;

      if (!eligibleBundle || !address || !linecheckId || !isAvailable) {
        lineCheckCallBack();
      }
      if (!content?.enableLinecheckOverlay && typeof lineCheckCallBack == 'function') {
        if (!eligibleBundle || !address || !linecheckId) {
          lineCheckCallBack();
        }
      }
      if (isAvailable) {
        //To track add to cart
        Object.keys(offerResponse)?.length !== 0 &&
          trackEligibleItem(ADDTOCART, [offerResponse[product?.productId]], '', STAGETEASER);
        setShowLoader(true);
        //Create cart call not triggered if offer api fails
        Object.keys(offerResponse)?.length !== 0 &&
          createCartWinV2(
            [offerResponse[code]],
            '',
            promoId ? promoId : DEFAULT_WIRELINE_BUNDLE,
            cartEndPoint,
            giftItem
          )
            .then((res) => {
              Cookies.remove('one-commerce-cartId', { path: '/' });
              // saving newly created cartid in the cookies.
              Cookies.set('one-commerce-cartId', res?.id, { path: '/' });
              Cookies.set('cartProduct', code, { path: '/' });
              Cookies.remove('landline');
              window.location.href = product?.ratePlanDetail?.[0]?.checkoutUrl?.cached_url;
            })
            .catch((err) => {
              // eslint-disable-next-line no-console
              console.log(err);
              setShowLoader(false);
            })
            .finally(() => {
              setShowLoader(false);
            });
      } else if (!eligibleBundle || !address || !linecheckId) {
        setShowLinecheck(true);
      }
    } else if (product?.productType === MOBILE) {
      //To track add to cart
      Object.keys(offerResponse)?.length !== 0 &&
        trackEligibleItem(ADDTOCART, [offerResponse[product?.productId]], '', STAGETEASER);
      const subGroupp = content?.isYoungProduct ? YOUTH : '';
      const vcType: { voucher: string; voucherType: string } = getLocalStorageWithExpiry('vctype');
      let nextUrl = contentData?.checkoutUrl?.url ?? '';
      const promoIdFromOffer = offerResponse?.[content?.productId]?.promotionInfo?.[0].id ?? '';
      setShowLoader(true);
      createCartV2(
        content?.productId,
        content?.productId,
        promoIdFromOffer,
        cartEndPoint,
        'mobile',
        '',
        '',
        '',
        content?.isQoQaFlow,
        ''
      )
        .then((response) => {
          if (response && response?.id !== '') {
            Cookies.remove('one-commerce-cartId', { path: '/' });
            // saving newly created cartid in the cookies.
            Cookies.set('one-commerce-cartId', response?.id, { path: '/' });
            window.location.href = nextUrl;
          }
        })
        .catch((error) => {
          // eslint-disable-next-line no-console
          console.log('error in cart call creation', error);
          setShowLoader(false);
        })
        .finally(() => {
          setShowLoader(false);
        });
    }
  };

  const fetchOfferingDataV2 = async (params: any, url: any): Promise<any> => {
    try {
      localStorage.removeItem('entertainment');
      const options = {
        headers: {
          'x-correlation-id': generateUID(),
          'x-sunrise-channel': APIResourceConstants.X_SUN_CHAL
        }
      };
      const URL = url + APIResourceConstants.LINE_TABLEV2;
      const productDynamicData: any = await ApiServiceV2.getApiServiceInstance()
        .post(URL, params, options)
        .then((res): any => {
          if (res.status == 200) {
            return res?.data;
          }
        });
      if (productDynamicData.error) {
        return productDynamicData.error;
      } else {
        const response: any[] = [];
        productDynamicData?.forEach((data: any) => {
          response[data.id] = data;
        });
        return response;
      }
    } catch (error: any) {
      // eslint-disable-next-line no-console
      console.log('error--->', error);
    }
  };
  const requestBody: any[] = [];

  if (
    content?.productId &&
    requestBody.filter((val) => val.id === content?.productId)?.length === 0
  ) {
    requestBody.push({
      id: content?.productId,
      promoIds: [
        content?.promotionId
          ? content?.promotionId
          : content?.productType === INTERNET
            ? DEFAULT_WIRELINE_BUNDLE
            : DEFAULT_MOBILEPOSTPAID_BUNDLE
      ]
    });
  }

  if (
    content?.tvProductId &&
    requestBody.filter((val) => val?.id === content?.tvProductId)?.length === 0
  ) {
    requestBody.push({
      id: content?.tvProductId,
      promoIds: [
        content?.tvProductPromotionId ? content?.tvProductPromotionId : DEFAULT_WIRELINE_BUNDLE
      ]
    });
  }
  useEffect(() => {
    const queryParams = window && new URLSearchParams(window?.location.search);
    const voucher: string | null = queryParams?.get('voucher');
    if (voucher) {
      try {
        getVocherPromotion(content?.productId, voucher).then((res: any) => {
          res && setLocalStoreWithExpiry('vctype', { voucher: voucher, voucherType: 'qoqa' });
        });
      } catch (err: any) {
        // eslint-disable-next-line no-console
        console.log('voucher qoqa Error');
      }
    }
    offerResponse?.length === 0 &&
      fetchOfferingDataV2(requestBody, endPoint)
        .then((data: any) => {
          if (data && Object.keys(data)?.length > 0) {
            setOfferResponse(data);
          }
        })
        .catch((error) => {
          // eslint-disable-next-line no-console
          console.log('error--->', error);
        });
  }, []);

  const priceSection = offerResponse?.[content?.productId]?.id
    ? createElement(() => {
        const offerData = offerResponse?.[content?.productId];
        let tvPrice: number;
        if (offerResponse[content?.tvProductId]?.derivedPrice) {
          tvPrice = offerResponse[content?.tvProductId]?.derivedPrice?.[0]?.value;
        } else {
          tvPrice = offerResponse[content?.tvProductId]?.prices?.[0]?.value;
        }
        return (
          <>
            {offerData?.id && (
              <div>
                {offerData?.derivedPrice?.length > 0 && offerData?.derivedPrice?.[0]?.value && (
                  <span className='discountrdPrice'>
                    <span>{offerData?.derivedPrice?.[0]?.value}</span>
                    <span className='priceDuration'>{contentData?.monthLabel}</span>
                  </span>
                )}
                {offerData?.prices?.[0]?.value && !contentData?.hideBasePrice && (
                  <span
                    className={offerData?.derivedPrice?.length > 0 ? 'basePrice' : 'actualPrice'}
                  >
                    {toggle ? countZero(tvPrice) : countZero(offerData?.prices?.[0]?.value)}
                    {!offerData?.derivedPrice && (
                      <span className='priceDuration'>{contentData?.monthLabel}</span>
                    )}
                  </span>
                )}
              </div>
            )}
          </>
        );
      })
    : '';

  let productPrice: number;
  const priceConatiner = () => {
    let tvPrice: number;
    const bundle = localStorage.getItem('lineCheckResponse');
    const eligibleBundle = bundle && JSON.parse(bundle);
    const code = toggle ? content?.tvProductId : content?.productId;
    const isAvailable = address && eligibleBundle?.eligibleBundle?.includes(code);

    if (offerResponse[content?.productId]?.derivedPrice) {
      productPrice = offerResponse[content?.productId]?.derivedPrice?.[0]?.value;
    } else {
      productPrice = offerResponse[content?.productId]?.prices?.[0]?.value;
    }

    if (offerResponse[content?.tvProductId]?.derivedPrice) {
      tvPrice = offerResponse[content?.tvProductId]?.derivedPrice?.[0]?.value;
    } else {
      tvPrice = offerResponse[content?.tvProductId]?.prices?.[0]?.value;
    }

    return (
      <div className=''>
        {offerResponse[content?.productId]?.prices?.[0]?.value > 0 && (
          <div className='priceSection'>
            <div>
              {productPrice && !toggle && (
                <div className='actualPrice'>{'CHF ' + countZero(productPrice) + '/mo'}</div>
              )}
              {tvPrice && toggle && (
                <div className={'actualPrice'}>{'CHF ' + countZero(tvPrice) + '/mo'}</div>
              )}
            </div>
            {contentData?.checkoutBtn && (
              <button
                className='proceedToCheckoutButton'
                onClick={() => {
                  // Check if login is required for enableLogin flow
                  if (
                    content?.enableLogin &&
                    !authData?.authvalues?.siteId &&
                    content?.loginBlok?.[0]
                  ) {
                    setShowLogin(true);
                    return;
                  }
                  return content?.linecheckData?.length > 0 &&
                    content?.linecheckData?.[0]?.reference?.default_full_slug ===
                      'global/coverage-check' &&
                    !isAvailable
                    ? setShowLinecheck(true)
                    : content?.enableLinecheckOverlay && !isAvailable
                      ? setShowLinecheck(true)
                      : callCart(content);
                }}
              >
                {content?.shoppingCart?.filename && (
                  <img src={content?.shoppingCart?.filename} alt='shopping-cart' />
                )}
                <span className='checkoutButton'>
                  {isAvailable ? contentData?.orderNowButton : contentData?.checkoutBtn}
                </span>
              </button>
            )}
            {contentData?.contractDuration &&
              offerResponse?.[code]?.promotionInfo?.[0]?.contractDuration && (
                <div className='contractDurationText'>
                  {replacePlaceholder(contentData?.contractDuration, [
                    offerResponse?.[code]?.promotionInfo?.[0]?.contractDuration
                  ])}
                </div>
              )}
          </div>
        )}
      </div>
    );
  };

  const combineWithSmartphone =
    contentData?.combineWithSmartphone && offerResponse?.id
      ? createElement(() => {
          return (
            <>
              {contentData?.combineWithSmartphone && (
                <a
                  href={combineWithSmartphoneUrl}
                  rel='opener'
                  target='_blank'
                  className='combineWithSmartphone'
                  // onClick={handleCombineWithMobile}
                >
                  <img src={content?.smartphone?.filename} alt='smartphone' />
                  <span>{contentData?.combineWithSmartphone}</span>
                </a>
              )}
            </>
          );
        })
      : '';

  //Analytics Promotion tracking
  useEffect(() => {
    if (content && content?.enableLinecheckOverlay) {
      setShowLinecheck(true);
    }
    content &&
      trackNewDatalayerEvent(VIEWPROMOTION, VIEWPROMOTION, {
        banner_promotion_name: content?.productDetails
      });
  }, [content]);

  //Analytics Product Details tracking
  useEffect(() => {
    click &&
      offerResponsefromApi &&
      trackNewDatalayerEvent(
        GAEVENT,
        DOWNLOADPRODUCT,
        getEcomCartInfo(offerResponsefromApi, contentData, STAGETEASER)
      );
  }, [click]);

  useEffect(() => {
    // setOfferResponse(offerResponsefromApi[0]);
    if (offerResponsefromApi && Object.keys(offerResponsefromApi)?.length > 0) {
      trackEligibleItem('view', offerResponsefromApi, contentData, STAGETEASER);
    }
  }, [offerResponsefromApi]);

  const handleCombineWithMobile = () => {
    //Analytics combine with smartphone tracking
    trackNewDatalayerEvent(
      GAEVENT,
      COMBINEDEVICE,
      getEcomCartInfo(offerResponsefromApi, contentData, STAGETEASER)
    );
  };

  const onLoginSuccess = () => {
    authData?.checklogin();
    if (requestBody?.length > 0) {
      setOfferResponse([]);
      fetchOfferingDataV2(requestBody, endPoint)
        .then((data: any) => {
          if (data && Object.keys(data)?.length > 0) {
            setOfferResponse(data);
          }
        })
        .catch((error) => {
          // eslint-disable-next-line no-console
          console.log('error--->', error);
        });
    }
    setShowLogin(!showLogin);
    setLoginButtonClicked(true);
  };

  const callWin = () => {
    //Analytics addtocart and Select Promotion tracking
    offerResponsefromApi &&
      trackEligibleItem(ADDTOCART, offerResponsefromApi, contentData, STAGETEASER);
    trackNewDatalayerEvent(SELECTPROMOTION, SELECTPROMOTION, {
      banner_promotion_name: content?.productDetails
    });
    window.location.href = contentData?.checkoutUrl?.cached_url;
  };
  const timer: TimerSchema = {
    startTime: contentData?.timer?.[0]?.startTime,
    endTime: contentData?.timer?.[0]?.endTime,
    expiryLabel: contentData?.timer?.[0]?.expiryLabel,
    dayLabel: contentData?.timer?.[0]?.dayLabel,
    hourLabel: contentData?.timer?.[0]?.hourLabel,
    minuteLabel: contentData?.timer?.[0]?.minuteLabel,
    secondLabel: contentData?.timer?.[0]?.secondLabel,
    expiryLabelColor: contentData?.timer?.[0]?.expireLabelColor,
    timerColor: contentData?.timer?.[0]?.timerColor,
    backgroundColor: '',
    mainHeading: '',
    timerAlignment: '',
    enableCounter: false
  };

  const timerObj = {
    startTimeContent: contentData?.timer?.[0]?.startTime,
    endTimeContent: contentData?.timer?.[0]?.endTime,
    enableCounter: contentData?.enableTimer
  };

  const [isTimerActive, setIsTimerActive] = useState(false);
  const timerFun = () => {
    CheckTime(timerObj, timer, setIsTimerActive);
    const timer1 = setInterval(() => {
      CheckTime(timerObj, timer, setIsTimerActive);
    }, 1000);
    return () => clearInterval(timer1);
  };
  useEffect(() => {
    if (contentData?.enableTimer) {
      timerFun();
    }
  }, []);
  const selectedGiftItem = (item: any) => {
    const itemValue = giftItem.findIndex((gift: any) => item.giftGroupId === gift.giftGroupId);
    const temp = giftItem;
    if (itemValue === -1) temp.push(item);
    else temp[itemValue] = item;
    setGiftItem([...temp]);
  };

  //once linecheck success set linecheck pop up false and proceed to checkout section
  const linecheckSuccess = () => {
    lineCheckSuccessCallBack();
  };

  const linecheckSuccessAndCart = () => {
    callCart(content);
    lineCheckSuccessCallBack();
  };

  const EditClick = () => {
    setEditClick(true);
    setShowLinecheck(true);
  };

  return (
    <>
      {content && viewPort && (
        <div
          className={`mainWrapper ${gradientStyle}`}
          style={hasGlobalGradient ? { background: normalizedGlobalGradient } : {}}
        >
          <Row>
            <>
              {showLoader && <Dotloader keyParams='loading' />}
              {content?.productDetails && <div className='details'>{content?.productDetails}</div>}
              <div className='teaserDescription'>
                <RichText content={content?.description} />
              </div>
              <div className='mainContainer'>
                <div className='teaserContainer'>
                  {content?.image?.filename && (
                    <div className='bannerImage'>
                      {viewPort !== 'mobile' ? (
                        <img src={content?.image.filename} alt='banner-image-desktop' />
                      ) : (
                        <img src={content?.mobImage?.filename} alt='banner-image-mobile' />
                      )}

                      {/* <!-- <GenericImage content={viewPort === 'mobile' ? bannerMobImageObj : bannerImageObj} /> --> */}
                    </div>
                  )}
                  <div className='productCard'>
                    {contentData?.title && (
                      <>
                        <h1 className='text-center'>{contentData?.title}</h1>
                        <hr />
                      </>
                    )}
                    {(content?.ratePlanDetail?.[0]?.ratePlanBloks || [])?.map((data: any) => {
                      return (
                        <>
                          {data?.description &&
                            !data?.addTV &&
                            data?.category &&
                            (data?.category === DEFAULT ||
                              offerResponse?.[content?.productId]?.prices?.[0]?.priceAlteration?.[0]
                                ?.priceCategory === data?.category) && (
                              <>
                                <div className='descriptions'>
                                  <span>
                                    <img
                                      src={data?.icon && data?.icon.filename}
                                      width='24px'
                                      height='24px'
                                      alt='benefit-icon'
                                    />
                                  </span>
                                  <span className='descriptionText'>{data?.description}</span>
                                  {data?.tooltip?.content?.[0]?.content?.[0]?.text && (
                                    <ToolTip content={<RichText content={data?.tooltip} />} />
                                  )}
                                </div>
                                <hr />
                              </>
                            )}
                          {data?.addTvDescription && data?.addTV && (
                            <>
                              <div className='descriptions2'>
                                <span>
                                  <img
                                    src={data?.icon && data?.icon.filename}
                                    width='24px'
                                    height='24px'
                                    alt='benefit-icon'
                                  />
                                </span>

                                <span className='descriptionText'>
                                  <RichText content={data?.addTvDescription} />
                                </span>
                                <div className='toggleContent'>
                                  <Form>
                                    <Form.Check
                                      type='switch'
                                      readOnly={true}
                                      onClick={() => setToggle(!toggle)}
                                      checked={toggle}
                                      // className='custom'
                                    />
                                  </Form>
                                </div>
                                {data &&
                                  data?.tooltip &&
                                  data?.tooltip?.content &&
                                  data?.tooltip?.content?.[0] &&
                                  data?.tooltip?.content?.[0]?.content &&
                                  data?.tooltip?.content?.[0]?.content?.[0] &&
                                  data?.tooltip?.content?.[0]?.content?.[0]?.text && (
                                    <div>
                                      <ToolTip
                                        className='tooltip'
                                        content={data?.tooltip?.content?.[0]?.content?.[0]?.text}
                                        icon={data?.tooltipicon}
                                      />
                                    </div>
                                  )}
                              </div>
                              <hr />
                            </>
                          )}
                        </>
                      );
                    })}
                    {authData?.authvalues?.siteId &&
                      loginButtonClicked &&
                      content?.isQoQaFlow &&
                      Object.keys(offerResponse)?.length > 0 &&
                      offerResponse?.[content?.productId]?.prices?.[0]?.priceAlteration?.[0]
                        ?.priceCategory !== QOQA_RATE_PLAN && (
                        <div className='notEligibleContainer'>
                          <div className='TextTitle'>{content?.notEligibleText}</div>
                          <div className='TextDesc'>{content?.notEligibleDescription}</div>
                        </div>
                      )}
                    {content?.loginTitle && !authData?.authvalues?.siteId && (
                      <div className='loginWrapper'>
                        <div className='d-flex flex-column'>
                          <span className='TextTitle'>{content?.loginTitle}</span>
                          <span className='TextDesc'>{content?.loginDescription}</span>
                        </div>
                        <button onClick={() => setShowLogin(true)}>
                          {content?.loginButtonLabel}
                        </button>
                      </div>
                    )}
                    {content?.singleGift?.map((item: any, index: number) => {
                      return <GiftConfigV2 content={item} key={index} />;
                    })}
                    <div>
                      {content?.chooseGift?.map((item: any, index: number) => {
                        return (
                          <ChooseGiftV2
                            content={item}
                            key={index}
                            selectedGiftItem={selectedGiftItem}
                            parentPoType={content?.parentPoType}
                          />
                        );
                      })}
                    </div>
                    {viewPort === MOBILE &&
                      Object.keys(offerResponse)?.length > 0 &&
                      content?.productType === INTERNET && (
                        <>
                          <div className='priceSection' />
                          {priceConatiner()}
                        </>
                      )}
                    {viewPort !== MOBILE &&
                      Object.keys(offerResponse)?.length > 0 &&
                      content?.productType === INTERNET && (
                        <>
                          {' '}
                          <div className='priceSection'>{priceConatiner()}</div>
                        </>
                      )}

                    {content?.productType === MOBILE &&
                      (offerResponse?.[content?.productId] ? (
                        <>
                          {priceSection && (
                            <div>
                              {offerResponse?.[content?.productId]?.id && (
                                <div className='priceSection'>
                                  {CURRENCY}{' '}
                                  {offerResponse?.[content?.productId]?.derivedPrice?.[0]
                                    ?.value && (
                                    <div className='priceValue'>
                                      {
                                        offerResponse?.[content?.productId]?.derivedPrice?.[0]
                                          ?.value
                                      }
                                      {contentData?.monthLabel && (
                                        <span className='duration'>{contentData?.monthLabel}</span>
                                      )}
                                    </div>
                                  )}
                                  {offerResponse?.[content?.productId]?.prices?.[0]?.value &&
                                    !contentData?.hideBasePrice && (
                                      <span
                                        className={
                                          offerResponse?.[content?.productId]?.derivedPrice
                                            ?.length > 0
                                            ? 'basePrice'
                                            : 'actualPrice'
                                        }
                                      >
                                        {countZero(
                                          offerResponse?.[content?.productId]?.prices?.[0]?.value
                                        )}
                                        {!offerResponse?.[content?.productId]?.derivedPrice &&
                                          contentData?.monthLabel && (
                                            <span className='duration'>
                                              {contentData?.monthLabel}
                                            </span>
                                          )}
                                      </span>
                                    )}
                                </div>
                              )}
                            </div>
                          )}

                          {contentData?.discountLabel && (
                            <div className='text-center'>{contentData?.discountLabel}</div>
                          )}
                          {contentData?.checkoutBtn && (
                            <button
                              className='proceedToCheckoutButton'
                              onClick={() => {
                                // Check if login is required for enableLogin flow
                                if (
                                  content?.enableLogin &&
                                  !authData?.authvalues?.siteId &&
                                  content?.loginBlok?.[0]
                                ) {
                                  setShowLogin(true);
                                  return;
                                }
                                callCart(content);
                              }}
                            >
                              <img src={content?.shoppingCart?.filename} alt='shopping-cart' />
                              <span className='checkoutButton'>{contentData?.checkoutBtn}</span>
                            </button>
                          )}
                          {contentData?.contractDuration &&
                            offerResponse?.[content?.productId]?.promotionInfo?.[0]
                              ?.contractDuration && (
                              <div className='contractDurationText'>
                                {replacePlaceholder(contentData?.contractDuration, [
                                  offerResponse?.[content?.productId]?.promotionInfo?.[0]
                                    ?.contractDuration
                                ])}
                              </div>
                            )}
                          {contentData?.enableTimer && isTimerActive && (
                            <div
                              className='fresh-timer'
                              style={{
                                background: contentData?.timer?.[0]?.backgroundColor?.color
                              }}
                            >
                              <Timer content={timer} />
                            </div>
                          )}
                          {combineWithSmartphone && (
                            <a
                              href={combineWithSmartphoneUrl}
                              rel='opener'
                              target='_blank'
                              className='combineWithSmartphone'
                              onClick={handleCombineWithMobile}
                            >
                              <img src={content?.deviceMobile?.filename} alt='device' />
                              <span>{contentData?.combineWithSmartphone}</span>
                            </a>
                          )}
                        </>
                      ) : (
                        <div style={{ textAlign: 'center' }}>
                          <SkeletonLoader count={1} />
                          {contentData?.checkoutBtn && (
                            <button
                              className='proceedToCheckoutButton ptc-disabled'
                              onClick={() => callCart(content)}
                              disabled={true}
                            >
                              <img src={content?.shoppingCart?.filename} alt='shopping-cart' />
                              <span className='checkoutButton'>{contentData?.checkoutBtn}</span>
                            </button>
                          )}
                        </div>
                      ))}
                    {contentData?.productDetailsLabel && (
                      <FreshProductDetails
                        click={click}
                        setClick={setClick}
                        buttonLabel={contentData?.productDetailsLabel}
                        content={contentData}
                        priceSection={priceSection}
                        durationText={contentData?.discountLabel}
                        combineWithSmartphone={combineWithSmartphone}
                        callCart={callCart}
                        offerResponse={offerResponse}
                        shoppingCart={content?.shoppingCart}
                      />
                    )}
                    {eligibleBundle &&
                      content &&
                      address &&
                      content?.productType !== MOBILE &&
                      (!isAvailable ? (
                        <span className='activeiconwrapper'>
                          <img
                            src={`/ecom-int/icons/cross_disabled.svg`}
                            alt=''
                            width='24px'
                            height='24px'
                            className={'inactiveicons'}
                          />
                          <span>{content?.serviceabilityError}</span>
                        </span>
                      ) : (
                        <span className='activeiconwrapper'>
                          <img
                            src={`/ecom-int/icons/lineCheck-success.svg`}
                            alt=''
                            width='24px'
                            height='24px'
                            className={'activeicons'}
                          />
                          <span>{content?.subscriptionAvailableText}</span>
                        </span>
                      ))}
                    {isAvailable && content?.productType !== MOBILE && (
                      <div className='changeAddress'>
                        <a onClick={EditClick}>{content?.changeAddress}</a>
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {/* llincheck modal */}
              {showLinecheck &&
              content?.enableLinecheckOverlay &&
              content?.productType === INTERNET &&
              content?.linecheckData?.length > 0 &&
              content?.linecheckData?.[0]?.reference?.default_full_slug ===
                'global/new-linecheck-test' ? (
                <LinecheckModal
                  content={content?.linecheckData?.[0]}
                  onSuccess={linecheckSuccessAndCart}
                  showModal={showLinecheck}
                  setShowModal={setShowLinecheck}
                  productName={contentData?.title}
                  editClick={editClick}
                />
              ) : showLinecheck &&
                content?.productType === INTERNET &&
                content?.linecheckData?.length > 0 &&
                content?.linecheckData?.[0]?.reference?.default_full_slug ===
                  'global/coverage-check' ? (
                <CoverageCheckModal
                  content={content?.linecheckData?.[0].reference.content.body[0]}
                  overlayIsOpen={true}
                  externalHandleModal={setShowLinecheck}
                  productName={contentData?.title}
                  showModal={showLinecheck}
                  setShowModal={setShowLinecheck}
                  onSuccess={linecheckSuccess}
                  onCreateCart={linecheckSuccessAndCart}
                  lineCheckOnClear={lineCheckOnClear}
                  productId={content?.productId}
                />
              ) : null}
              {!authData?.authvalues?.siteId && showLogin && content?.loginBlok?.[0] && (
                <LoginModalV2
                  content={content?.loginBlok?.[0]}
                  closeLogin={() => setShowLogin(false)}
                  metadata={metadata}
                  onSuccess={onLoginSuccess}
                  isProdEnv={isProdEnv}
                />
              )}
            </>
          </Row>
        </div>
      )}
    </>
  );
};

export default FreshProductBannerHome;
